import IconChevronDown from '@apollo/icons/default/IconChevronDown.svg';
import IconChevronUp from '@apollo/icons/default/IconChevronUp.svg';
import IconDocument from '@apollo/icons/large/IconDocument.svg';
import IconEducation from '@apollo/icons/large/IconEducation.svg';
import IconExplorer from '@apollo/icons/large/IconExplorer.svg';
import { Button, Card, CardBody, CardHeader, Link } from '@apollo/orbit';
import React, { useState } from 'react';
import { useRouteMatch } from 'react-router-dom';

import * as orgRoutes from 'src/app/account/routes';
import { sandboxExplorerRouteConfig } from 'src/app/graph/routes';
import { DocsRouter, OdysseyRouter } from 'src/lib/routers';

export const AdditionalResourcesSection = () => {
  const [educationDrawerOpen, setEducationDrawerOpen] = useState(false);

  const isOnSupergraphTab = !!useRouteMatch(orgRoutes.graphs.definition);

  return (
    <>
      <Button
        variant="hidden"
        className="mb-4 mt-6"
        onClick={() => setEducationDrawerOpen((prev) => !prev)}
        rightIcon={
          educationDrawerOpen ? <IconChevronUp /> : <IconChevronDown />
        }
      >
        Looking for additional resources?
      </Button>
      {educationDrawerOpen && (
        <div className="mx-auto flex flex-wrap justify-center gap-4 pb-10 text-left">
          <Card className="group h-64 w-44">
            <CardHeader>
              <IconExplorer className="self-start" />
            </CardHeader>
            <CardBody className="justify-between">
              <div>Test a locally running server with Apollo Sandbox.</div>
              <Link
                to={sandboxExplorerRouteConfig.location({})}
                {...(isOnSupergraphTab && {
                  'data-analytics-label':
                    'Go to Sandbox click on Empty Supergraph Page',
                  'data-analytics-category': '6M2S: Onboarding',
                })}
              >
                Go to Sandbox
              </Link>
            </CardBody>
          </Card>

          <Card className="group h-64 w-44">
            <CardHeader>
              <IconEducation className="self-start" />
            </CardHeader>
            <CardBody className="justify-between">
              <div>Learn GraphQL with our hands-on tutorials.</div>
              <Link
                isExternal
                to={OdysseyRouter.path('Home')}
                {...(isOnSupergraphTab && {
                  'data-analytics-label':
                    'Odyssey click on Empty Supergraph Page',
                  'data-analytics-category': '6M2S: Onboarding',
                })}
              >
                View tutorials
              </Link>
            </CardBody>
          </Card>

          <Card className="group h-64 w-44">
            <CardHeader>
              <IconDocument className="self-start" />
            </CardHeader>
            <CardBody className="justify-between">
              <div>Dive into all things Apollo with our documentation.</div>
              <Link
                isExternal
                to={DocsRouter.path('Home')}
                {...(isOnSupergraphTab && {
                  'data-analytics-label': 'Docs click on Empty Supergraph Page',
                  'data-analytics-category': '6M2S: Onboarding',
                })}
              >
                Explore docs
              </Link>
            </CardBody>
          </Card>
        </div>
      )}
    </>
  );
};
